"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _logoLibrary = require("./logo-library");

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./Logo.css");

var _styles = {
  "logo": "Logo__logo___13PI_",
  "button": "Logo__button___3GXDt"
};

const styles = _bind.default.bind(_styles);

const Logo = (0, _mobxReact.observer)(({
  className,
  dataTestId,
  type,
  width,
  height,
  onClick,
  disabled,
  ...props
}) => {
  const composed_classname = (0, _bind.default)(styles('logo', {
    button: !!onClick
  }), className);
  const logo = _logoLibrary.LogoProperties[type || 'default'] || _logoLibrary.LogoProperties.default;
  const viewBox = `0 0 ${logo.width} ${logo.height}`;
  const hasDimensions = width !== undefined || height !== undefined;
  return onClick ? _react.default.createElement("button", {
    "data-testid": dataTestId,
    className: composed_classname,
    type: 'button',
    onClick: onClick,
    disabled: disabled,
    role: 'button',
    ...props
  }, _react.default.createElement("svg", {
    width: hasDimensions ? width : logo.width,
    height: hasDimensions ? height : logo.height,
    viewBox: viewBox,
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, logo.paths)) : _react.default.createElement("svg", {
    "data-testid": dataTestId,
    className: composed_classname,
    width: hasDimensions ? width : logo.width,
    height: hasDimensions ? height : logo.height,
    viewBox: viewBox,
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    ...props
  }, logo.paths);
});
var _default = Logo;
exports.default = _default;